import * as React from "react";
import { BlossomComponentTree } from "./BlossomComponentTree";

/**
 * TEMPORARY WILL BE UNNECESSARY AFTER HYBRID BLOSSOM REFACTOR COMPLETE
 */
export const BlossomComponentTreeContext = React.createContext<BlossomComponentTree | undefined>(undefined);
